:host {
  background-color: var(--white-layout-300-primary);
  max-width: 100%;
}

.wrapper {
  flex-direction: column;
  height: 100%;
}
